export default "__VITE_ASSET__CQeuadSK__"